"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.closePortsToast = exports.openPortsToast = exports.createPortSuccess = exports.createPortError = exports.createPort = exports.onHideSavePrompt = exports.onShowSavePrompt = exports.filterPortsByCountry = exports.getPortsSuccess = exports.getPortsError = exports.getPorts = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    ports: [],
    hasErrorLoadingPorts: false,
    arePortsLoading: false,
    filteredPorts: [],
    isSavePromptVisible: false,
    isCreatingPort: false,
    createPortError: false,
    createPortSuccess: false,
    portToastStatus: { isOpen: false, message: "", status: undefined },
};
const portsSlice = (0, toolkit_1.createSlice)({
    name: "ports",
    initialState,
    reducers: {
        getPorts: (state) => {
            state.arePortsLoading = true;
        },
        getPortsSuccess: (state, action) => {
            state.arePortsLoading = false;
            state.ports = action.payload;
        },
        getPortsError: (state) => {
            state.hasErrorLoadingPorts = true;
            state.arePortsLoading = false;
        },
        filterPortsByCountry: (state, action) => {
            const filterPortsByCountry = state.ports.filter((port) => {
                return port.country.id === action.payload;
            }) || [];
            state.filteredPorts = filterPortsByCountry;
        },
        onShowSavePrompt: (state) => {
            state.isSavePromptVisible = true;
        },
        onHideSavePrompt: (state) => {
            state.isSavePromptVisible = false;
        },
        createPort: (state) => {
            state.isCreatingPort = true;
        },
        createPortSuccess: (state) => {
            state.isCreatingPort = false;
            state.createPortSuccess = true;
        },
        createPortError: (state) => {
            state.isCreatingPort = false;
            state.createPortError = true;
        },
        openPortsToast: (state, action) => {
            state.portToastStatus.status = action.payload.status;
            state.portToastStatus.message = action.payload.message;
            state.portToastStatus.isOpen = true;
        },
        closePortsToast: (state) => {
            state.portToastStatus.isOpen = false;
            state.portToastStatus.status = undefined;
            state.portToastStatus.message = "";
        },
    },
});
_a = portsSlice.actions, exports.getPorts = _a.getPorts, exports.getPortsError = _a.getPortsError, exports.getPortsSuccess = _a.getPortsSuccess, exports.filterPortsByCountry = _a.filterPortsByCountry, exports.onShowSavePrompt = _a.onShowSavePrompt, exports.onHideSavePrompt = _a.onHideSavePrompt, exports.createPort = _a.createPort, exports.createPortError = _a.createPortError, exports.createPortSuccess = _a.createPortSuccess, exports.openPortsToast = _a.openPortsToast, exports.closePortsToast = _a.closePortsToast;
exports.default = portsSlice.reducer;
